import Vue from 'vue'

export const stripP = (str) => {
  if(!str) {
    return '';
  }
  return str.replace('<p>', '').replace('</p>', '').replace('<P>', '').replace('</P>', '')
}

Vue.filter('stripP', stripP)
